import { create } from 'zustand';

interface AttemptsStore {
  attempts: number;
  setAttempts: (attempts: number) => void;
  blocked: boolean;
  setBlocked: (blocked: boolean) => void;
}

const useAttemptsStore = create<AttemptsStore>((set) => ({
  attempts: 0,
  blocked: false,
  setAttempts: (attempts: number) => set({ attempts }),
  setBlocked: (blocked: boolean) => set({ blocked }),
}));

export default useAttemptsStore;
